import type { WritableRegions } from '../primitives/use-writable-regions';

import type { VenueCreateForm } from './useVenueCreateForm';
import { VenueAddressFields } from './VenueAddressFields';
import { ASSIGN_FROM_STATE } from './venueCreateFields';
import { VenueRegionField } from './VenueRegionField';

export function LocationStep({
  form,
  writable,
}: {
  form: VenueCreateForm;
  writable: WritableRegions;
}) {
  const { stage } = form;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {stage === 'prospect' && (
        <p style={{ fontSize: 11.5, color: 'var(--nb-subtle)', lineHeight: 1.5, margin: 0 }}>
          {
            "Prospects don't need an address yet — you can add it on the venue page once they're booked."
          }
        </p>
      )}
      <VenueAddressFields form={form} />
      <VenueRegionField
        regions={writable.regions}
        loading={writable.loading}
        failed={writable.failed}
        value={form.regionId}
        error={form.regionError}
        clearLabel={ASSIGN_FROM_STATE}
        onChange={form.setRegionId}
      />
    </div>
  );
}
